





import Vue, { PropType } from 'vue';
// import { options } from '../../modules/options';

import { options } from 'mostra';
// import { buyerWorkKindOptions } from '@/modules/options';
//
export type optionsType = {
  value: number;
  text: string;
};

// export type dataType = {
//   options: optionsType[];
// };

export default Vue.extend({
  name: 'GWorkKindCheckbox',
  data() {
    return {
      options: options.buyerWorkKindOptions,
    };
  },
  computed: {
    innerValue: {
      get(): number[] {
        return this.value;
      },
      set(val: number[]): void {
        this.$emit('input', val);
      },
    },
  },
  props: {
    value: Array as PropType<number[]>,
    isCheckBoxTwoLines: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
});
